// Mock events data for the Caribbean LGBTQ+ travel platform
const mockEvents = [
  {
    id: 1,
    title: "San Juan Pride Festival",
    description: "Join us for the largest Pride celebration in the Caribbean! Featuring parades, beach parties, and cultural events throughout San Juan.",
    location: "San Juan, Puerto Rico",
    startDate: "2025-06-25",
    endDate: "2025-06-29",
    image: "https://www.discoverpuertorico.com/sites/default/files/2023-05/Pride%20Celebration%20in%20Puerto%20Rico.jpg",
    category: "pride",
    organizer: {
      id: 1,
      name: "Maria Sanchez"
    },
    attendees: 120,
    isFeatured: true,
    tags: ["pride", "festival", "nightlife", "culture"],
    website: "https://sanjuanpride.com",
    ticketRequired: true,
    price: "Free - $50",
    accessibility: ["wheelchair-accessible", "asl-interpretation"]
  },
  {
    id: 2,
    title: "Caribbean Queer Art Exhibition",
    description: "A showcase of LGBTQ+ artists from across the Caribbean region, exploring themes of identity, belonging, and resistance.",
    location: "Kingston, Jamaica",
    startDate: "2025-07-10",
    endDate: "2025-07-30",
    image: "https://images.squarespace-cdn.com/content/v1/5c7d60a711f7846b870727fc/1578448146634-4TMHGFD7J8O4RGECWQYV/Ebony+G.+Patterson%2C+...when+they+grow+up...%2C+2016%2C+mixed+media+jacquard+woven+photo+tapestry+with+handmade+shoes%2C+embellished+with+jewelry%2C+fabric%2C+glitter%2C+and+toys.jpg",
    category: "art",
    organizer: {
      id: 6,
      name: "Marcus Johnson"
    },
    attendees: 85,
    isFeatured: true,
    tags: ["art", "culture", "exhibition"],
    website: "https://caribbeanqueerart.org",
    ticketRequired: true,
    price: "$15",
    accessibility: ["wheelchair-accessible"]
  },
  {
    id: 3,
    title: "Diving Trip for LGBTQ+ Travelers",
    description: "Join marine biologist Sophie Williams for a guided diving experience exploring the coral reefs of Bonaire. All experience levels welcome!",
    location: "Kralendijk, Bonaire",
    startDate: "2025-08-05",
    endDate: "2025-08-07",
    image: "https://www.tourismbonaire.com/includes/images/gallery/diving-bonaire.jpg",
    category: "adventure",
    organizer: {
      id: 3,
      name: "Sophie Williams"
    },
    attendees: 12,
    isFeatured: false,
    tags: ["diving", "adventure", "nature", "eco-tourism"],
    website: "https://sophiedives.com/lgbtq-trips",
    ticketRequired: true,
    price: "$250",
    accessibility: ["experienced swimmers only"]
  },
  {
    id: 4,
    title: "Queer Caribbean Literary Festival",
    description: "A celebration of LGBTQ+ Caribbean authors, poets, and storytellers. Featuring readings, workshops, and panel discussions.",
    location: "Bridgetown, Barbados",
    startDate: "2025-09-15",
    endDate: "2025-09-18",
    image: "https://www.visitbarbados.org/sites/default/files/parliament_buildings.jpg",
    category: "culture",
    organizer: {
      id: 9,
      name: "Olivia Smith"
    },
    attendees: 65,
    isFeatured: true,
    tags: ["literature", "culture", "education"],
    website: "https://caribbeanlitfest.com",
    ticketRequired: true,
    price: "$25 - $100",
    accessibility: ["wheelchair-accessible", "hearing-impaired accommodations"]
  },
  {
    id: 5,
    title: "OutCaribbean Sailing Adventure",
    description: "A week-long sailing trip through the US and British Virgin Islands. Connect with fellow LGBTQ+ travelers while island hopping on a private yacht.",
    location: "St. Thomas, USVI to Tortola, BVI",
    startDate: "2025-10-10",
    endDate: "2025-10-17",
    image: "https://www.travellady.com/wp-content/uploads/British-Virgin-Islands-Sailing.jpeg",
    category: "adventure",
    organizer: {
      id: 10,
      name: "James Walker"
    },
    attendees: 8,
    isFeatured: true,
    tags: ["sailing", "adventure", "island-hopping"],
    website: "https://outcaribbeansailing.com",
    ticketRequired: true,
    price: "$1,800",
    accessibility: ["swimming ability required"]
  },
  {
    id: 6,
    title: "Havana LGBTQ+ Food Tour",
    description: "Explore the culinary delights of Havana with local restaurant owner Elena Rodriguez. Visit LGBTQ+ friendly establishments and learn about Cuban cuisine.",
    location: "Havana, Cuba",
    startDate: "2025-07-22",
    endDate: "2025-07-22",
    image: "https://www.traveloffpath.com/wp-content/uploads/2023/03/Havana-Cuba-Travel-Guide-Top-Things-To-Do-In-Havana.jpg",
    category: "food",
    organizer: {
      id: 7,
      name: "Elena Rodriguez"
    },
    attendees: 15,
    isFeatured: false,
    tags: ["food", "culture", "walking tour"],
    website: "https://elenascuisine.com/tours",
    ticketRequired: true,
    price: "$75",
    accessibility: ["wheelchair-accessible"]
  },
  {
    id: 7,
    title: "Trinidad Carnival LGBTQ+ Meetup",
    description: "Experience the vibrant energy of Trinidad Carnival with local guide Alex Rivera. Special focus on LGBTQ+ friendly events and spaces.",
    location: "Port of Spain, Trinidad",
    startDate: "2026-02-16",
    endDate: "2026-02-17",
    image: "https://www.travelandleisure.com/thmb/Q5wGYK1JJK9-_QVLOHM8JRGSBiA=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/trinidad-carnival-TRINICARNI0217-b2a0a89832134e4f9c67c8fa41de80b7.jpg",
    category: "festival",
    organizer: {
      id: 4,
      name: "Alex Rivera"
    },
    attendees: 40,
    isFeatured: true,
    tags: ["carnival", "festival", "culture", "nightlife"],
    website: "https://alexriveratours.com/carnival",
    ticketRequired: true,
    price: "$200",
    accessibility: ["high energy event"]
  },
  {
    id: 8,
    title: "Digital Nomad LGBTQ+ Coworking Week",
    description: "Join fellow LGBTQ+ digital nomads for a week of coworking, networking, and adventure in Aruba. Includes accommodation and workspace.",
    location: "Oranjestad, Aruba",
    startDate: "2025-08-18",
    endDate: "2025-08-25",
    image: "https://www.aruba.com/sites/default/files/styles/hero_image_desktop_1920x744/public/content/header/Palm_Beach_Aruba_sunset_1920x744.jpg",
    category: "digital nomad",
    organizer: {
      id: 2,
      name: "David Chen"
    },
    attendees: 25,
    isFeatured: false,
    tags: ["digital nomad", "networking", "coworking"],
    website: "https://queernomads.com/aruba",
    ticketRequired: true,
    price: "$850",
    accessibility: ["wifi provided", "wheelchair-accessible"]
  },
  {
    id: 9,
    title: "Caribbean LGBTQ+ Travel Safety Workshop",
    description: "An online workshop focused on travel safety for LGBTQ+ individuals visiting the Caribbean. Learn about local laws, cultural considerations, and safety tips.",
    location: "Virtual Event",
    startDate: "2025-07-05",
    endDate: "2025-07-05",
    image: "https://www.caribbeanlifenews.com/wp-content/uploads/2019/06/Caribbean-flags-e1559947151621.jpg",
    category: "education",
    organizer: {
      id: 9,
      name: "Olivia Smith"
    },
    attendees: 150,
    isFeatured: true,
    tags: ["safety", "education", "virtual"],
    website: "https://rainbowcaribbeantravel.com/workshops",
    ticketRequired: true,
    price: "$25",
    accessibility: ["closed captioning", "multilingual options"]
  },
  {
    id: 10,
    title: "Bahamas LGBTQ+ Beach Weekend",
    description: "A relaxing weekend getaway on a private beach in the Bahamas. Connect with fellow travelers in a safe and inclusive environment.",
    location: "Nassau, Bahamas",
    startDate: "2025-09-05",
    endDate: "2025-09-07",
    image: "https://www.travelandleisure.com/thmb/KTIha5CLifSoUD1NE9HfqoG6aDc=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/pink-sand-beach-harbour-island-bahamas-PINKBEACH0217-d27869558b8c4089b087b54445f1a582.jpg",
    category: "social",
    organizer: {
      id: 9,
      name: "Olivia Smith"
    },
    attendees: 35,
    isFeatured: false,
    tags: ["beach", "relaxation", "social"],
    website: "https://rainbowcaribbeantravel.com/bahamas-weekend",
    ticketRequired: true,
    price: "$350",
    accessibility: ["beach wheelchair available"]
  }
];

export default mockEvents;
